import React, { useState, useEffect, useRef } from "react";
import { loadModules } from "esri-loader";
import { centre } from "../data/centre";
import { Box } from "@chakra-ui/react";

const symbol = {
  type: "picture-marker",
  url: centre,
  width: 46,
  height: 35,
};

export function showLocation(view, item) {
  loadModules(["esri/Graphic", "esri/support/actions/ActionButton"]).then(
    ([Graphic, ActionButton]) => {
      const {
        StoreNumber,
        StoreName,
        StreetAddress,
        state,
        Postcode,
        Contact,
        Longitude,
        Latitude,
        tags,
        attributes,
      } = item;
      // console.log(StoreName, StreetAddress, Contact, bookLink);
      const graphic = new Graphic({
        attributes,
        geometry: {
          type: "point",
          latitude: Latitude,
          longitude: Longitude,
        },
        symbol,
        popupTemplate: {
          title: "{name}",
          content:
            "{addr}<br />Contact: {contact}<br /> <a href='https://donationcenter.youcanbook.me/'>Book Appointment</a>",
        },
      });
      graphic.popupTemplate.actions = [
        new ActionButton({
          title: "Route me",
          id: "route-to-debris",
          className: "esri-icon-directions2",
        }),
      ];
      view.graphics.add(graphic);
    }
  );
}

export default function DrawMapView(props) {
  const mapRef = useRef();

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);

  useEffect(() => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(
      [
        "esri/widgets/Sketch",
        "esri/Map",
        "esri/layers/GraphicsLayer",
        "esri/views/MapView",
        "esri/WebMap",
      ],
      { css: true }
    ).then(
      ([
        Sketch,
        Map,
        GraphicsLayer,
        MapView,
        WebMap,
      ]) => {
        // const { REACT_APP_GLOBAL_API_KEY } = process.env;
        // if (!REACT_APP_GLOBAL_API_KEY) {
        //   throw new Error("API key not found");
        // }

        // esriConfig.apiKey = REACT_APP_GLOBAL_API_KEY;

        const layer = new GraphicsLayer();

        // const map = new Map({
        //   basemap: "streets",
        //   layers: [layer],
        // });

        const map = new WebMap({
            portalItem: {
              // autocasts as new PortalItem()
              id: "7c9200faf0404b90a1238cc2e4bfe63d"
            }
          });

        const view = new MapView({
          container: mapRef.current,
          map: map,
          zoom: 11,
          center: [
            props.centerx ? props.centerx : -118.22469981770287,
            props.centery ? props.centery : 33.98250165665902,
          ],
        });

        // const sketch = new Sketch({
        //   layer: layer,
        //   view: view,
        //   creationMode: "update",
        // });
        // view.ui.add(sketch, "top-right");

        console.log(props.points.length);
        // console.log(props.centerx,props.centery);

        props.points.forEach((each) => {
          if (each) showLocation(view, each);
        });

        view.popup.on("trigger-action", (event) => {

          if (event.action.id === "route-to-debris") {
            window.open("https://donationcenter.youcanbook.me/", '_blank');
          }
        });

        return () => {
          if (view) {
            view.container = null;
          }
        };
      }
    );
  });

  return (
    <Box
      as="div"
      // maxW={{ base: "2xl", md: "7xl", lg: "7xl" }}
      style={{
        width:
          (windowDimenion.winWidth * 0.09 >= 90
            ? 90
            : windowDimenion.winWidth * 0.09 <= 85
            ? 85
            : windowDimenion.winWidth * 0.09) + "vw",
        // width: '90%',
        height: windowDimenion.winHeight * 0.094 + "vh",
      }}
      ref={mapRef}
    />
  );
}
